import { ApiClient } from "./clients";
import { ListService, Team } from "@/types";
import { TeamSharingSettings } from "@/types/teamSharing";

export interface TeamListService extends ListService<Team> {
  loadTeamSharingSettings: () => Promise<TeamSharingSettings>;
}

export const TeamsService: TeamListService = {
  async all() {
    return await ApiClient.get<Team[]>(`/api/v1/teams/`);
  },
  async load(id: number) {
    return await ApiClient.get<Team>(`/api/v1/team/${id}/`);
  },
  async loadTeamSharingSettings() {
    const teamSharingSettings = await ApiClient.get<TeamSharingSettings>(
      "/api/v1/teams/team-sharing-settings/?ticket_type=issue"
    );
    return teamSharingSettings ?? {};
  },
};
